<template>
  <div>
    <div v-if="loading" class="dw-loading">
      <b-spinner small></b-spinner> Loading...
    </div>
    <div v-else-if="!timeline" class="dw-empty">No actuals processed in this period.</div>
    <fi-timeline-chart
      v-else
      :rows="timeline.rows"
      :series="timeline.series"
      :height="240"
      chart-label="Actuals per day by processing status"
    />
  </div>
</template>

<script>
import moment from 'moment'
import FiTimelineChart from '../charts/fi_timeline_chart.vue'

// semantic status colors, palette-validated per theme with the dataviz
// six-checks script (2026-08-01). the old softened set failed both cvd
// gates (success green vs error red ΔE 3.8 deutan): softening toward
// white compresses the lightness differences cvd readers depend on. the
// stack order (success, unprocessed, cancelled, error) is part of the
// validated set -- it keeps red and amber from touching, which cannot be
// made safe in the dark steps.
const STATUS_SERIES = [
  { key: 'success_cnt', label: 'Success', light: '#2e8663', dark: '#27a075' },
  { key: 'unprocessed_cnt', label: 'Unprocessed', light: '#d39410', dark: '#bd8524' },
  { key: 'cancelled_cnt', label: 'Cancelled', light: '#9aa4af', dark: '#5f6e7d' },
  { key: 'error_cnt', label: 'Error', light: '#c74444', dark: '#e46666' },
]

export default {
  name: 'widget_actuals_by_status',
  components: { FiTimelineChart },
  props: {
    summary: { type: Object, default: null },
    loading: { type: Boolean, default: false },
    daysRange: { type: Number, default: 7 },
  },
  computed: {
    isMidnight() {
      return this.$store.state.profile.site_theme === 'midnight'
    },
    // the dashboard's range selection, as exactly that many days of bars.
    // the tenant-dashboard query already windows summary.stats to the same
    // count; this keeps the chart honest if it ever hands back a wider span
    // (a stale cached payload, a caller passing its own days). oldest go.
    windowedStats() {
      const stats = (this.summary && this.summary.stats) || []
      return stats.slice(-this.daysRange)
    },
    // day-by-status stacked rows, built from the same tenant-dashboard
    // summary.stats the Actuals Summary widget uses -- calc_daily_stats.py
    // already buckets each day's actuals into these 4 statuses, so unlike
    // Alerts By Type this doesn't need its own raw-record fetch.
    timeline() {
      const stats = this.windowedStats
      if (!stats.length) return null
      const mode = this.isMidnight ? 'dark' : 'light'
      return {
        series: STATUS_SERIES.map(s => ({ label: s.label, color: s[mode] })),
        rows: stats.map(({ date, stats: dayStats = {} }) => {
          const a = dayStats.actuals || {}
          return {
            label: moment(String(date)).format('MM/DD'),
            values: STATUS_SERIES.map(s => Number(a[s.key] || 0)),
          }
        }),
      }
    },
  },
}
</script>
